define.alias("shared/components/shared/post/secondary/hashtag-suggestions/auto", "auth/components/shared/post/secondary/hashtag-suggestions/auto");